var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    this.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "news-list-right" }, [
          _c("div", { staticClass: "positionRE" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "news-article-list" },
              _vm._l(_vm.recommodList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "newsArticle-list-bar positionRE pointEr",
                    on: {
                      click: function($event) {
                        return _vm.gotoPath(item)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "displayIB" },
                      [
                        _c("imgPath", {
                          attrs: {
                            src: item.articleImg,
                            outstyle: {
                              width: 79 * (100 / 960) + "vw",
                              height: 52 * (100 / 960) + "vw"
                            },
                            domain: item.articleImg
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "displayIB newsArticle-list-right" },
                      [
                        _c(
                          "p",
                          { staticClass: "newsArticle-list-tlt font16px" },
                          [_vm._v(_vm._s(item.articleTitle))]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "newsArticle-list-time font14px col99999 positionAB"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-down",
                                staticStyle: { "margin-left": "0" }
                              },
                              [
                                _c("imgPath", {
                                  attrs: { src: _vm.src, domain: _vm.src }
                                })
                              ],
                              1
                            ),
                            _vm._v(_vm._s(item.submissionTime))
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _c("div", [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "news-hot-list" },
              _vm._l(_vm.hotList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    on: {
                      click: function($event) {
                        return _vm.gotoPath(item)
                      }
                    }
                  },
                  [
                    index == 0
                      ? _c(
                          "div",
                          { staticClass: "news-hot-topBar positionRE" },
                          [
                            _c("imgPath", {
                              attrs: {
                                src: item.articleImg,
                                outstyle: {
                                  width: 175 * (100 / 960) + "vw",
                                  height: 115 * (100 / 960) + "vw"
                                },
                                domain: item.articleImg
                              }
                            }),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "font16px news-hot-topText positionAB colffffff overflowText"
                              },
                              [_vm._v(_vm._s(item.articleTitle))]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "article-hotList-p pointEr font16px" },
                      [
                        _c("span", { staticClass: "article-hotList-span" }, [
                          _vm._v(_vm._s(index + 1 + "."))
                        ]),
                        _c(
                          "span",
                          { staticClass: "overflowText article-hotList-span2" },
                          [_vm._v(_vm._s(item.articleTitle))]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        ])
      : _c("div")
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "font30px positionAB news-article-tlt" }, [
      _c("div", { staticClass: "article-tlt-hr displayIB" }),
      _c("span", { staticClass: "article-tlt" }, [_vm._v("最新文章")]),
      _c("div", { staticClass: "article-tlt-hr displayIB" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "font30px hot-article-tlt" }, [
      _c("div", { staticClass: "article-tlt-hr displayIB" }),
      _c("span", { staticClass: "article-tlt" }, [_vm._v("热门文章")]),
      _c("div", { staticClass: "article-tlt-hr displayIB" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3c0ec62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3c0ec62","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/articleSidebar/articleSidebar.vue
// module id = 839
// module chunks = 3 4 5 10